<div class="flex items-center gap-x-2">
    @if(view.includes('signal')) {
    <ng-container *ngIf="signal; else signalNone">
        <span [nzTooltipColor]="'#fff'" nz-tooltip [nzTooltipTitle]="signal.toString()" style="font-size: 1.4rem;"
            class="cursor-pointer" nz-icon [nzType]="'hezky:Signal_High'" nzTheme="outline"></span>
    </ng-container>
    }
    @if(view.includes('battery')) {
    <ng-container *ngIf="batteryPercentage; else batteryNone">
        <ng-container [ngSwitch]="true">
            <span *ngSwitchCase="batteryPercentage === 0" [nzTooltipColor]="'#fff'" nz-tooltip
                [nzTooltipTitle]="batteryPercentage.toFixed(0) + '%'" class="text-xl cursor-pointer text-red-500" nz-icon
                [nzType]="'hezky:Battery_None'" nzTheme="outline"></span>
            <span *ngSwitchCase="batteryPercentage > 0 && batteryPercentage <= 20" [nzTooltipColor]="'#fff'" nz-tooltip
                [nzTooltipTitle]="batteryPercentage.toFixed(0) + '%'" class="text-xl cursor-pointer text-orange-500" nz-icon
                [nzType]="'hezky:Battery_Low'" nzTheme="outline"></span>
            <span *ngSwitchCase="batteryPercentage > 20 && batteryPercentage <= 50" [nzTooltipColor]="'#fff'" nz-tooltip
                [nzTooltipTitle]="batteryPercentage.toFixed(0) + '%'" class="text-xl cursor-pointer text-yellow-500" nz-icon
                [nzType]="'hezky:Battery_Medium'" nzTheme="outline"></span>
            <span *ngSwitchCase="batteryPercentage > 50 && batteryPercentage != 255" [nzTooltipColor]="'#fff'" nz-tooltip
                [nzTooltipTitle]="batteryPercentage.toFixed(0) + '%'" class="text-xl cursor-pointer text-green-500" nz-icon
                [nzType]="'hezky:Battery_High'" nzTheme="outline">
            </span>
            <span *ngSwitchCase="batteryPercentage > 200" [nzTooltipColor]="'#fff'" nz-tooltip
                [nzTooltipTitle]="'Battery Charging'" class="text-2xl cursor-pointer text-red-500" nz-icon
                [nzType]="'hezky:Battery_Charging'" nzTheme="outline">
            </span>
        </ng-container>
    </ng-container>
    }
</div>

<ng-template #signalNone>
    <span nz-tooltip nzTooltipTitle="No Signal" nzTooltipPlacement="top" nzTooltipColor="#fff" nz-icon
        style="font-size: 1.2rem;" class="mb-1 cursor-pointer" [nzType]="'hezky:Signal_None'"
        nzTheme="outline"></span>
</ng-template>

<ng-template #batteryNone>
    <span nz-tooltip nzTooltipTitle="No Battery" nzTooltipPlacement="top" nzTooltipColor="#fff" nz-icon
        class="text-xl cursor-pointer text-gray-400" [nzType]="'hezky:Battery_None'" nzTheme="outline"></span>
</ng-template>